import React, { useEffect, useRef, useState } from 'react';

/** CountUp — animated counter on first in-view. */
export default function CountUp({
  to = 0,
  from = 0,
  duration = 1.6,
  suffix = '',
  prefix = '',
  className = '',
}) {
  const ref = useRef(null);
  const [val, setVal] = useState(from);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    let raf;
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        const start = performance.now();
        const tick = (t) => {
          const k = Math.min(1, (t - start) / (duration * 1000));
          const eased = 1 - Math.pow(1 - k, 3);
          setVal(Math.round(from + (to - from) * eased));
          if (k < 1) raf = requestAnimationFrame(tick);
        };
        raf = requestAnimationFrame(tick);
        obs.unobserve(e.target);
      });
    }, { threshold: 0.4 });
    obs.observe(el);
    return () => { obs.disconnect(); if (raf) cancelAnimationFrame(raf); };
  }, [from, to, duration]);
  return <span ref={ref} className={className}>{prefix}{val}{suffix}</span>;
}
